module.exports = __webpack_public_path__ + "8a04845132.woff2";